// Top-level toast renderer. Listens for events from src/lib/toast.js and
// stacks them at the bottom-right of the viewport. Auto-dismisses after
// 5s for info, 8s for errors.
import React, { useEffect, useState } from 'react';
import { subscribe } from '../lib/toast';

const COLORS = {
  info:  { bg: '#1a1030', border: '#4a3880', text: '#BC9EFF' },
  error: { bg: '#1a0508', border: '#7a1a1a', text: '#ff8c8c' },
};

let _id = 0;

export default function Toast() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    // Track timeout handles so we can clear them on unmount and avoid
    // setState-after-unmount (route changes, hot reload).
    const timeouts = new Map();

    const unsubscribe = subscribe(({ message, kind }) => {
      const id = ++_id;
      setItems(curr => [...curr, { id, message, kind }]);
      const ttl = kind === 'error' ? 8000 : 5000;
      const handle = setTimeout(() => {
        timeouts.delete(id);
        setItems(curr => curr.filter(i => i.id !== id));
      }, ttl);
      timeouts.set(id, handle);
    });

    return () => {
      unsubscribe();
      timeouts.forEach(h => clearTimeout(h));
      timeouts.clear();
    };
  }, []);

  if (!items.length) return null;

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 20, display: 'flex', flexDirection: 'column', gap: 8, zIndex: 9999 }}>
      {items.map(item => {
        const c = COLORS[item.kind] || COLORS.info;
        return (
          <div
            key={item.id}
            role={item.kind === 'error' ? 'alert' : 'status'}
            style={{ background: c.bg, border: `0.5px solid ${c.border}`, color: c.text, padding: '12px 16px', borderRadius: 6, fontSize: 13, maxWidth: 400, lineHeight: 1.5, boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }}>
            {item.message}
          </div>
        );
      })}
    </div>
  );
}
